<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<span class="field-box">
  @switch (lfFieldInfo.fieldType) {
    @case (fieldTypeDateTime) {
      <lf-date-time-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lf-date-time-field-component>
    }
    @case (fieldTypeString) {
      <lf-text-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lf-text-field-component>
    }
    @case (fieldTypeDate) {
      <lf-date-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lf-date-field-component>
    }
    @case (fieldTypeShortInteger) {
      <lf-number-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lf-number-field-component>
    }
    @case (fieldTypeLongInteger) {
      <lf-number-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lf-number-field-component>
    }
    @case (fieldTypeList) {
      <lf-list-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lf-list-field-component>
    }
    @case (fieldTypeNumber) {
      <lf-number-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lf-number-field-component>
    }
    @case (fieldTypeTime) {
      <lf-time-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lf-time-field-component>
    }
  }
</span>
